import Money from '@square/dashboard-money/models/money';

export function initialize(): void {
  // Hardcoding this to USD is only ok because we only put U.S. merchants through the onboarding flow.
  // Setting the default currency is required for the currency input component.
  Money.defaultCurrencyCode = 'USD';
}

export default {
  initialize,
};
